import { render, staticRenderFns } from "./ArtisanSwitch.vue?vue&type=template&id=f10d565a"
import script from "./ArtisanSwitch.vue?vue&type=script&lang=js"
export * from "./ArtisanSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports